import React, { createContext, useRef, useEffect, useContext, useImperativeHandle, useReducer, useState } from 'react'
import { RendererContext } from '@/components/FURenderkit'
import { RENDER_SDK, RESOURCE_MANAGER } from '@/config'
import Avatar from './Avatar'
import { ModifiedScene } from '@/packages/sdk/fu_render_kit/lib/RenderKitSDK'

interface ISceneConfig {
    Camera: string,
    Light: string,
    Background: string,
}

const originSceneConfig = {
    Camera: '',
    Light: '',
    Background: '',
}

const sceneConfigReduce = (sceneConfig: ISceneConfig, action: {
    type: keyof ISceneConfig | 'reset'
    value?: any
}) => {
    if (action.type === 'reset') {
        return originSceneConfig
    }
    sceneConfig[action.type] = action.value
    return { ...sceneConfig }
}

export const SceneContext = createContext<{
    handleCameraChange: (type: string) => void
    scheduleUpdateResources: () => void
    scene?: ModifiedScene
}>({
    handleCameraChange: () => { },
    scheduleUpdateResources: () => { }
})
const Scene = (props) => {
    const { renderer } = useContext(RendererContext)
    const [scene, setScene] = useState<ModifiedScene | undefined>()
    const [sceneConfig, sceneConfigDispatch] = useReducer(sceneConfigReduce, originSceneConfig)

    useEffect(() => {
        if (renderer) {
            // 场景初始化
            console.log('12345')
            sceneInit()
        }
    }, [renderer])

    useEffect(() => {
        if (scene) {
            setDefaultSceneConfig()
        }
    }, [scene])

    useEffect(() => {
        scheduleUpdateResources()
    }, [sceneConfig])

    function sceneInit() {
        if (!renderer) return
        const scene = renderer.customCreateScene()
        scene.enableRenderPostProcess(
            RENDER_SDK.EPostProcessType.POST_PROCESS_MIRROR,
            false
        )
        // 设置全透明清屏色
        scene.setRenderClearColor([0, 0, 0, 0])
        // 关闭 MSAA 获得更好兼容性
        scene.setRenderMsaaLevel(RENDER_SDK.EMSAAOption.MSAA_NONE)
        // 开启 FXAA 后处理
        scene.enableRenderPostProcess(
            RENDER_SDK.EPostProcessType.POST_PROCESS_FXAA,
            true
        )
        // 关闭法线重计算 提升性能
        // scene.setConfig({ enable_recomputer_normal: 0});
        setScene(scene)
    }

    // 获取背景、光照、相机准备设置场景
    function setDefaultSceneConfig() {
        let cameraType = 'cam_AvatarX_hengping'
        const defaultCamera = RESOURCE_MANAGER.snapshot.list.find(
            (item) => item.path.indexOf(cameraType) !== -1
        )
        if (defaultCamera) {
            sceneConfigDispatch({
                type: 'Camera',
                value: defaultCamera.path
            })
        }
        const defaultLight = RESOURCE_MANAGER.snapshot.list.find(
            (item) => item.path.indexOf('light_man') !== -1
        )
        if (defaultLight) {
            sceneConfigDispatch({
                type: 'Light',
                value: defaultLight.path
            })
        }
        const defaultBackground = RESOURCE_MANAGER.snapshot.list.find(
            (item) => item.path.indexOf('bg_ptag.bundle') !== -1
        )
        console.log('defaultBackground', defaultBackground)
        if (defaultBackground) {
            sceneConfigDispatch({
                type: 'Background',
                value: defaultBackground.path
            })
        }
    }

    // 设置相机光照背景
    async function scheduleUpdateResources() {
        const requests: Promise<any>[] = []
        // 统一设置背景、灯光、相机
        for (let [type, path] of Object.entries(sceneConfig)) {
            if (path) {
                requests.push(
                    scene?.[`set${type}Async`](path)
                )
            }
        }
        if (requests.length === 0) {
            return
        }
        await Promise.all(requests)
        // 清空减少下次请求次数
        sceneConfigDispatch({
            type: 'reset',
        })
    }

    function handleCameraChange(type) {
        if (type === "banshen") {
            sceneConfigDispatch({
                type: 'Camera',
                value: 'GAssets/camera/scene/cam_ptag_banshen.bundle'
            })
        } else if (type === "quanshen") {
            sceneConfigDispatch({
                type: 'Camera',
                value: 'GAssets/camera/scene/cam_ptag_quanshen.bundle'
            })
        }
    }

    // 场景scene初始化完毕
    const avatarRef = useRef<any>(null)
    useEffect(() => {
        console.log('scene', scene)
        if (scene) {
            avatarRef.current.avatarInit()
        }
    }, [scene])

    return (
        <div className='scene'>
            <SceneContext.Provider
                value={
                    {
                        scene,
                        handleCameraChange,
                        scheduleUpdateResources,
                    }
                }
            >
                <Avatar
                    ref={avatarRef}
                />
            </SceneContext.Provider>
        </div>
    )
}

export default Scene
